import { render, staticRenderFns } from "./OrganizationListView.vue?vue&type=template&id=6c2f3ca0&"
import script from "./OrganizationListView.vue?vue&type=script&lang=js&"
export * from "./OrganizationListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports